import screenfull from 'screenfull';
import common from '../common';
import Scene from './Scene';
import {GlitchFilter} from 'pixi-filters';
import {translate, Text} from '../utils';

export default class SplashScene extends Scene {
	constructor() {
		super();

		this.inTween 		= null;
		this.outTween 		= null;
		this._playButton 	= null;
		this._muteButton 	= null;
		this._glitchContainer = null;
		this.destroyed 		= false;

		this._lastGlitch = Date.now();
		this._glitchTimer = 2000;		// ms
		this._glitchFilter = null;
		this._bgMusic = null;

		this.isIE = this.detectIE();

		this.timeouts = [];
	}

	init() {
		super.init();
		let cookie = JSON.parse(localStorage.getItem('cheats'));

		cookie = cookie ? cookie.enabled : false;
		common.cheatActive = cookie || common.config.cheat_mode;

		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));
		bg.anchor.set(0.5);
		bg.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5));
		bg.width = 2000;
		this.addChild(bg);

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));
			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), (common.STAGE_HEIGHT * 0.5));
			this.addChild(codetile);
		}

		this._glitchContainer = new PIXI.Container();
		this.addChild(this._glitchContainer);

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		frameTop.position.set(common.STAGE_WIDTH * 0.5, 0);
		this._glitchContainer.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this._glitchContainer.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT + frameBottom1.height);

		new P3.utils.TWEEN.Tween(frameTop.position, this.tweens)
			.to({
				y: frameTop.y + frameTop.height
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.start();

		new P3.utils.TWEEN.Tween(frameBottom.position, this.tweens)
			.to({
				y: frameBottom.y - frameBottom.height
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.start();

		const aliens = new PIXI.Sprite(P3.assets.texture('ui_char_aliens'));
		aliens.anchor.set(0.5);
		aliens.position.set((common.STAGE_WIDTH * 0.5) + 255, (common.STAGE_HEIGHT * 0.5) - 25);
		aliens.scale.set(0);
		this._glitchContainer.addChild(aliens);

		const ben = new PIXI.Sprite(P3.assets.texture('ui_char_ben_1'));
		ben.anchor.set(0.5, 1);
		ben.position.set((common.STAGE_WIDTH * 0.5) - 300, common.STAGE_HEIGHT);
		ben.scale.set(0);
		this._glitchContainer.addChild(ben);

		const logo = new PIXI.Sprite(P3.assets.texture('ui_ben10_logo'));
		logo.anchor.set(0.5);
		logo.visible = false;
		logo.scale.set(2);
		logo.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5) - 150);
		this._glitchContainer.addChild(logo);

		const hackathonlogo = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_hackaton_logo'), 130, 100, 40, 61);
		hackathonlogo.scale.set(2);
		hackathonlogo.visible = false;
		this._glitchContainer.addChild(hackathonlogo);

		const gameTitle = translate('GAME.TITLE').split('');
		const titleText = Text('', {font: '60px Title', align: 'center'});
		titleText.tint = 0xFFFFFF;
		titleText.anchor.set(0.5);
		hackathonlogo.addChild(titleText);

		const addTitleLetter = (time, letter) => {
			const timeout = setTimeout(() => {
				if (titleText.text.length === 1) {
					P3.audio.playSound('sfx_terminal_typing_00');
				}

				if (letter) {
					titleText.text += letter;
				}

				hackathonlogo.height = titleText.height + 100;
				hackathonlogo.width = titleText.width + 100;
				titleText.position.set((hackathonlogo.width * 0.5), (hackathonlogo.height * 0.5) - 15);
				hackathonlogo.position.set((common.STAGE_WIDTH * 0.5) - (hackathonlogo.width * 0.5), logo.y + 150);
			}, time);

			this.timeouts.push(timeout);
		};

		addTitleLetter(0, null);

		for (const i in gameTitle) {
			addTitleLetter(2500 + (i * 100), gameTitle[i]);
		}

		const lt = new P3.utils.TWEEN.Tween(logo.scale, this.tweens)
			.to({x: 1, y: 1}, 500)
			.easing(P3.utils.Easing.Back2.Out)
			.onComplete(() => {
				hackathonlogo.visible = true;

				new P3.utils.TWEEN.Tween(hackathonlogo.scale, this.tweens)
					.to({x: 1, y: 1}, 300)
					.easing(P3.utils.Easing.Back2.Out)
					.start();
			});

		new P3.utils.TWEEN.Tween(ben.scale, this.tweens)
			.to({x: 1, y: 1}, 300)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(1000)
			.start();

		new P3.utils.TWEEN.Tween(aliens.scale, this.tweens)
			.to({x: 1, y: 1}, 300)
			.easing(P3.utils.Easing.Back2.Out)
			.delay(1200)
			.onComplete(() => {
				logo.visible = true;
				lt.start();
			})
			.start();

		if (common.config.competition_enabled) {
			const competitionPanel = new PIXI.mesh.NineSlicePlane(P3.assets.texture('collectables_splash_panel'), 10, 10, 10, 10);

			competitionPanel.height = 100;
			competitionPanel.position.set(
				(common.STAGE_WIDTH * 0.5) - (competitionPanel.width * 0.5),
				(common.STAGE_HEIGHT - 100) - (competitionPanel.height * 0.5)
			);
			this.addChild(competitionPanel);

			const competitionBadge = new PIXI.Sprite(P3.assets.texture('collectables_splash_badge'));

			competitionBadge.anchor.set(0.5);
			competitionBadge.position.set(competitionPanel.x + 30, common.STAGE_HEIGHT - 100);
			this.addChild(competitionBadge);

			const panelHeader = Text(translate('MENU.SPLASH.WIN'), {font: '32px Ahkio Regular', align: 'center'});

			panelHeader.tint = 0xFFFFFF;
			panelHeader.anchor.set(0.5, 0);
			panelHeader.position.set((competitionPanel.width * 0.5), 10);
			competitionPanel.addChild(panelHeader);

			const panelLabel = Text(translate('MENU.SPLASH.PLAY'), {font: '24px Ahkio Regular', align: 'center'});

			panelLabel.tint = 0xFFFFFF;
			panelLabel.anchor.set(0.5, 0);
			panelLabel.maxWidth = 260;
			panelLabel.position.set((competitionPanel.width * 0.5), panelHeader.y + panelHeader.height + 5);
			competitionPanel.addChild(panelLabel);

			competitionPanel.height = panelLabel.height + panelHeader.height + 30;
			competitionPanel.position.set(
				(common.STAGE_WIDTH * 0.5) - (competitionPanel.width * 0.5),
				(common.STAGE_HEIGHT - 100) - (competitionPanel.height * 0.5)
			);
		}

		let states = new P3.ButtonStates();

		states.normal 	= P3.assets.texture('ui_btn_xxl_out');
		states.over 	= P3.assets.texture('ui_btn_xxl_over');
		states.down 	= P3.assets.texture('ui_btn_xxl_down');
		states.icon 	= P3.assets.texture('ui_icon_play');

		this._playButton = new P3.Button(states);
		this._playButton.signals.click.add(this.onPlayClick, this);
		this._playButton.clickSoundName = 'sfx_btn_press_00';
		this._playButton.overSoundName = 'sfx_btn_rollover_00';
		this._playButton.position.set((common.STAGE_WIDTH * 0.5) + 390, (common.STAGE_HEIGHT * 0.5) + 225);
		this.addChild(this._playButton);

		this.outTween = new P3.utils.TWEEN.Tween(this._playButton, this.tweens)
			.to({
				rotation: this._playButton.rotation - (5 * PIXI.DEG_TO_RAD)
			}, 200)
			.easing(P3.utils.Easing.Back2.Out)
			.start();

		this.inTween = new P3.utils.TWEEN.Tween(this._playButton, this.tweens)
			.to({
				rotation: this._playButton.rotation + (5 * PIXI.DEG_TO_RAD)
			}, 200)
			.easing(P3.utils.Easing.Back2.Out)
			.onComplete(() => {
				P3.utils.delay(1, () => {
					if (!this.destroyed) {
						this.outTween.start();
					}
				});
			});

		this.outTween.onComplete(() => {
			return this.inTween.start();
		});

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_sound_on');
		states.iconAlt = P3.assets.texture('ui_icon_sound_off');

		this._muteButton = new P3.MuteButton(states);
		this._muteButton.signals.click.add(common.toggleAudio);
		this._muteButton.clickSoundName = 'sfx_btn_press_00';
		this._muteButton.overSoundName = 'sfx_btn_rollover_00';
		this._muteButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 75, 75);
		this.addChild(this._muteButton);

		this._glitchFilter = new GlitchFilter();
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH;
			line.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT / count) * i);
			this._glitchContainer.addChild(line);

			// up-down anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					y: line.position.y + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			const angle = P3.math.random(-10, 10);

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 1);
			line.rotation = angle * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, (common.STAGE_HEIGHT * 0.5));
			this._glitchContainer.addChild(line);

			// left-right anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					x: line.position.x + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	detectIE() {
		const ua = window.navigator.userAgent;

		const msie = ua.indexOf('MSIE ');

		if (msie > 0) {
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		const trident = ua.indexOf('Trident/');

		if (trident > 0) {
			const rv = ua.indexOf('rv:');

			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		const edge = ua.indexOf('Edge/');

		if (edge > 0) {
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		return false;
	}

	glitch() {
		this._glitchFilter.seed = Math.random();
		this._glitchFilter.slices = P3.math.randomInt(3, 6);
		this._glitchFilter.offset = P3.math.randomInt(-20, 20);
		this._glitchFilter.red = {x: -11.2, y: 2};
		this._glitchFilter.blue = {x: 10.0, y: -4};
		this._glitchFilter.red = {x: -10.0, y: 4};
		this._glitchFilter.fillMode = 2;			// transparent: 0, original: 1, loop: 2, clamp: 3, mirror: 4
		this._glitchContainer.filters = [this._glitchFilter];

		P3.utils.delayg(this.tweens, 0.1, () => {
			this._glitchContainer.filters = null;
		});
	}

	appear() {
		super.appear();
		P3.audio.stopMusic();
		this._bgMusic = P3.audio.playMusic('music_splash_screen_00');
	}

	onPlayClick() {
		if (PIXI.utils.isMobile.android.device && screenfull.enabled) {
			screenfull.request();
		}

		common.t.track('game launch event', {gamelaunch: 1});

		P3.audio.stopMusic();
		P3.audio.playSound('music_splash_playsting_00');
		this.signals.next.dispatch(this);
	}

	destroy() {
		for (let i = 0; i < this.timeouts.length; i++) {
			clearTimeout(this.timeouts[i]);
		}

		// clean up goes here
		this.destroyed = true;
		this.outTween.stop();
		this.inTween.stop();
		this._bgMusic.stop();
		P3.audio.stopMusic();
		super.destroy();
	}

	resize() {
		super.resize();
		this._muteButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 75, 75);
		this._playButton.position.set((common.STAGE_WIDTH * 0.5) + 390, (common.STAGE_HEIGHT * 0.5) + 225);
	}

	update() {
		super.update();

		if (!this.isIE && (Date.now() - this._lastGlitch > this._glitchTimer)) {
			this._lastGlitch = Date.now();
			this._glitchTimer = P3.math.random(100, 3000);

			this.glitch();
		}
	}
}
